export default "__VITE_ASSET__DyMmEhjW__"